import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { ChartsModule } from 'ng2-charts';
import { CommonModule } from '@angular/common';
import { Daterangepicker } from 'ng2-daterangepicker';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { SharedModule } from 'app/_shared/shared.module';
import { ReportsComponentModule } from 'app/views/reports-component/reports-component.module';
import { CKEditorModule } from 'ng2-ckeditor';
import {NgxPaginationModule} from 'ngx-pagination'; // <-- import the module
import { DiscussionMarketShareService } from './discussion-market-share.service';
import { DiscussionMarketShareComponent } from './discussion-market-share.component';

const routes: Routes = [
  {
    path: '',
    component: DiscussionMarketShareComponent,
    data: {
      title: 'Báo cáo thị phần các thương hiệu'
    },
  }
];
@NgModule({
  imports: [
    ChartsModule,
    TabsModule,
    BsDatepickerModule.forRoot(),
    CommonModule,
    DataTablesModule,
    Daterangepicker,
    HttpClientModule,
    RouterModule.forChild(routes),
    AngularMultiSelectModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    ReportsComponentModule,
    CKEditorModule,
    NgxPaginationModule
  ],
  declarations: [DiscussionMarketShareComponent],
  providers: [DiscussionMarketShareService]
})
export class DiscussionMarketShareModule { }



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-module/discussion-market-share/discussion-market-share.module.ts